<template>
    <div id="share-root">

        <!-- error message -->
        <div v-if="bad_uuid" class="section">
            <h1 class="title has-text-centered">Page not found</h1>
        </div>

        <!-- replacement header navbar -->
        <nav class="navbar fixed-top">
            <div class="navbar-brand is-horizontal-center">
                <a class="navbar-item" href="http://analogstudio.co.uk">
                    <figure class="image">
                        <img src="../assets/analog_logo.png">
                    </figure>
                </a>
            </div>

            <h1 class="navbar-item is-hidden-mobile">
                {{ reviewableshare.title }}
            </h1>

            <div class="navbar-end">
                <h1 class="navbar-item is-hidden-mobile">
                    {{ reviewableshare.date_created | relative_datetime }}
                </h1>
            </div>
        </nav>


        <section class="hero">
            <div class="hero-body">
                <div class="container">

                    <h1 class="title">
                        {{ reviewableshare.title }}
                    </h1>

                    <h2 class="subtitle">
                        {{ reviewableshare.date_created | relative_datetime}}
                    </h2>
                </div>
            </div>
        </section>


        <div id="revcard-container" class="container">

            <!-- not using card anymore simple divs are better -->
            <div class="revshare-card"
                v-for="reviewable in reviewables"
                v-bind:key="reviewable.id"
            >

                <video
                    v-if=ReviewableIsVideo(reviewable)
                    controls
                    loop
                    preload="none"
                    v-bind:poster=GetThmURL(reviewable)
                    v-bind:src=GetUploadURL(reviewable)
                >
                </video>
                <img v-else v-bind:src=GetThmURL(reviewable)>


                <router-link v-if='is_user_loggedin' class='title rev-title' :to="{ name: 'single', params: {id: reviewable.id } }">
                    {{ reviewable.name }}
                </router-link>

                <h1 v-else class='title rev-title'>
                    {{ reviewable.name }}
                </h1>
                
                <!-- swap elements touch or desktop! -->
                <a @click="Download(reviewable)" class="is-text is-hidden-mobile">
                    <span>
                        <b-icon icon="download" size="is-small"></b-icon>
                        Download Original
                    </span>
                </a>

                <a @click="Download(reviewable)"
                    class="button is-large is-hidden-tablet"
                >
                    <span>
                        <b-icon icon="download" size="is-small"></b-icon>
                        Download Original
                    </span>
                </a>
                <b-progress v-if="reviewable.is_downloading" :value=reviewable.download_percentage show-value format="percent" type="is-primary" size="is-large"></b-progress>
            </div>
        </div>

        <footer class="footer">
            <div v-if="!bad_uuid" class="content has-text-centered is-size-5">
                <p>Share Created<br>{{ reviewableshare.date_created | relative_datetime }}</p>
            </div>

            <div class="has-text-centered is-size-7">
                <p>
                    <b-icon icon="map-marker" size="is-small"></b-icon>
                    <a href='https://www.google.com/maps/place/Analog/@51.525964,-0.1103944,17z/data=!3m1!4b1!4m5!3m4!1s0x48761b457bb54d7b:0x1e15d6cd270336a1!8m2!3d51.525964!4d-0.1082057'>1 Rosoman Place, Clerkenwell, London, EC1R 0JY</a>
                </p>
                <p>
                    <b-icon icon="at" size="is-small"></b-icon>
                    <a href='mailto:studio@analogstudio.co.uk'>studio@analogstudio.co.uk</a>
                </p>
                <p>
                    <b-icon icon="cellphone-basic" size="is-small"></b-icon>
                    <a href='tel:00442035882020'>+44 (0) 203 588 2020</a>
                </p>
            </div>
        </footer>

    </div>
</template>

<script>
    import axios from 'axios'

    import { date_filters } from '../mixins/Filters'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    // for is_user_admin
    import { GetUserAdmin } from '../mixins/users'

    export default {
        mixins: [date_filters, GetAxiosAuthConfig, GetUserAdmin],
        data() {
            return {
                // Set data propertie from the router (routes.js)
                uuid: this.$route.params.uuid,
                bad_uuid: false,

                // Data properties for the den api
                reviewableshare: {},
                
                // built from the reviewable share
                reviewables: [],
                reviewableshare_loading: true,
            }
        },
        // watch to see if router has changed, update uuid
        watch: {
            '$route'(to, from){
                this.uuid = to.params.uuid
            }
        },
        methods: {
            forceFileDownload(response) {
                // get filename from url
                // split before aws presign
                let file_url = response.config.url.split("?")[0]
                let filename = file_url.split('\\').pop().split('/').pop();

                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
            },
            Download(reviewable) {
                
                console.log(reviewable)
                reviewable.is_downloading = true
                
                axios({
                    method: 'get',
                    url: reviewable.file_upload,
                    responseType: 'arraybuffer',
                    onDownloadProgress: ( progressEvent ) => {
                        let percentage = Math.round(( progressEvent.loaded / (progressEvent.total) ) * 100 )
                        // max 95, then set 100 when request is done
                        reviewable.download_percentage = Math.min(Math.max(parseInt(percentage), 0), 95)
                    }
                })
                .then(response => {
                    // this only runs when its fully downloaded

                    // set as 100 when done
                    reviewable.download_percentage = 100

                    // Finished loading
                    reviewable.is_downloading = false
                    // reset
                    reviewable.download_percentage = 0

                    this.forceFileDownload(response)
                })
                .catch(() => console.log('error occured'))
            },
            // ALL COPIED FROM REVCARD!!! EXCEPT AT A DIFFERENT 'LEVEL' THESE ALL NOW REQUIRE TO BE TOLD WHICH REVIEWABLE
            HasFileUpload(reviewable) {
                if (reviewable.file_upload == null) {
                    // old style
                    return true
                }
                else {
                    return false
                }
            },
            GetUploadURL(reviewable) {
                if (this.HasFileUpload(reviewable)) {
                    // old style
                    return reviewable.url
                }
                else {
                    // new style
                    return reviewable.file_upload
                }
            },
            GetThmURL(reviewable) {
                if (this.HasFileUpload(reviewable)) {
                    // old style
                    return reviewable.url + '.thm'
                }
                else {
                    // new style
                    return reviewable.thumbnail
                }
            },
            ReviewableIsVideo(reviewable) {
                // console.info("reviewable", reviewable)

                // cover old style url param
                if (this.HasFileUpload(reviewable)) {
                    // check url instead
                    var upload = reviewable.url
                }
                else {
                    var upload = reviewable.file_upload
                }

                // check extension
                // TODO this is so basic
                var video_extensions = ['mp4', 'mov', 'avi']

                let file_url = upload.split("?")[0]

                // if it is a gif, load the original image now the thumb
                if (video_extensions.includes(file_url.split(".").pop().toLowerCase())) {
                    return true
                }
                else {
                    return false
                }
            },
            GetReviewableShare() { // similar to get reviewables
                // Use the URL rather than the filter for ID
                // var resturl = window.location.origin + '/api/reviewableshares/' + this.uuid + '/?format=json'
                if (process.env.NODE_ENV == 'development') {
                    console.info("this.uuid", this.uuid)
                }

                // filter by UUID
                let resturl = window.location.origin + '/api/reviewableshares/?uuid=' + this.uuid + '&format=json'

                if (process.env.NODE_ENV == 'development') {
                    console.info("GetReviewableShare() resturl1", resturl)
                }

                axios
                .get(resturl)
                .then(response => {
                    // catch a non existant UUID, no results
                    if (response.data.count == 0) {
                        if (process.env.NODE_ENV == 'development') {
                            console.info("bad uuid")
                        }
                        this.bad_uuid = true
                        return
                    }

                    // UUID returns like this syntax
                    this.reviewableshare = response.data.results[0]
                    
                    if (process.env.NODE_ENV == 'development') {
                        console.info('GetReviewableShare() result reviewableshare:', this.reviewableshare)
                    }

                    // set as not loading
                    this.reviewableshare_loading = false

                    // the reviewables are now fully included (serialised) in the reviewable share's result from the api
                    // this.reviewables =  response.data.results[0].reviewables

                    // filter by UUID
                    let revs_resturl = window.location.origin + '/api/reviewableshares/' + this.reviewableshare.id + '/reviewables/?format=json'

                    if (process.env.NODE_ENV == 'development') {
                        console.info("GetReviewableShare() revs_resturl", revs_resturl)
                    }

                    axios.get(revs_resturl)
                    .then(response => {
                        // catch an error
                        if (response.data.count == 0) {
                            if (process.env.NODE_ENV == 'development') {
                                console.info("bad reviewable action")
                            }
                            // this.bad_uuid = true
                            return
                        }

                        // store reviewables
                        this.reviewables = response.data
                        
                        // add downloading attributes to manage each rev
                        this.reviewables.forEach(element => {
                            // need to use set ! https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
                            this.$set(element, 'is_downloading', false)
                            this.$set(element, 'download_percentage', 0)
                        });
                    })           
                    .catch(error => console.log(error))
                })
                .catch(error => console.log(error))
            },
        },
        mounted() { // once mounted (ie. wait for mounted)
            this.GetReviewableShare()
        },
    }
</script>


<style lang="scss" scoped>

    $light_bg : #dddbd4;

    a:hover {
        color: initial;
        text-decoration: underline;
    }
    .revshare-card {
        margin: 0 0 4rem 0;
    }

    .revshare-card img, .revshare-card video {
        max-height: 60vh;
    }

    .card-content {
        background-color: inherit;
    }

    #share-root, .footer {
        background-color: $light_bg;
    }

    .navbar-item img {
        width: auto;
    }

    .rev-title {
        margin: 0;
    }
    
</style>
